import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import AvaliacaoDialog from '../components/AvaliacaoDialog';
import OptimizedImage from '../components/OptimizedImage';

const Ultimate = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white ultimate-page">
      <Header onOpenForm={() => setIsFormOpen(true)} />
      
      {/* Page Header */}
      <PageHeader 
        title="SOBRE NÓS"
        subtitle="CONHECE A EQUIPA DE PROFISSIONAIS DEDICADOS"
        backgroundImage="/assets/ultimate-header.webp"
      />

      {/* Introdução / Posicionamento - Layout 2 Colunas */}
      <section className="py-14 sm:py-20 md:py-32 bg-white">
        <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* Texto */}
            <div>
              <h2 
                className="text-black uppercase mb-8"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "clamp(40px, 6vw, 70px)",
                  letterSpacing: "0.05em",
                  lineHeight: "1.1"
                }}
              >
                Quem somos
              </h2>
              <p 
                className="text-gray-700 text-base md:text-lg leading-relaxed mb-6"
                style={{
                  letterSpacing: "0.01em",
                  lineHeight: "1.6"
                }}
              >
                Fundado por dois profissionais unidos pela mesma crença: que o treino de excelência deve estar ao alcance de todos.
              </p>
              <p 
                className="text-gray-700 text-base md:text-lg leading-relaxed mb-8"
                style={{
                  letterSpacing: "0.01em",
                  lineHeight: "1.6"
                }}
              >
                Juntaram a experiência, método e dedicação para criar um espaço onde cada pessoa é tratada como única - com planos de treino personalizados, acompanhamento próximo e um ambiente que inspira a dar sempre o melhor.
              </p>
              <div className="flex justify-center md:justify-start">
                <button
                  onClick={() => setIsFormOpen(true)}
                  className="bg-black hover:bg-gray-900 text-white uppercase px-8 sm:px-10 py-4 transition-colors w-full sm:w-auto max-w-sm sm:max-w-none whitespace-normal sm:whitespace-nowrap"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    fontSize: "clamp(16px, 2vw, 20px)",
                    letterSpacing: "1px",
                    borderRadius: "0px"
                  }}
                >
                  MARCAR AVALIAÇÃO FÍSICA GRATUITA
                </button>
              </div>
            </div>
            
            {/* Imagem */}
            <div className="relative h-[420px] sm:h-[400px] md:h-[500px]">
              <OptimizedImage 
                src="/assets/ultimate-trainers.jpg"
                alt="ULTIMATE FIT Training Team"
                className="w-full h-full object-cover ultimate-trainers-img"
                style={{ 
                  filter: "grayscale(0.2)"
                }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Quem Somos - Layout Invertido */}
      <section className="py-14 sm:py-20 md:py-32 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
            {/* Imagem à esquerda */}
            <div className="relative h-[320px] sm:h-[400px] md:h-[500px]">
              <img 
                src="/assets/ult-resultados.webp"
                alt="ULTIMATE FIT - Treino para resultados reais"
                loading="lazy"
                className="w-full h-full object-cover"
                style={{ filter: "grayscale(0.15)", objectPosition: "center 30%" }}
              />
            </div>
            
            {/* Texto à direita */}
            <div>
              <h2 
                className="text-black uppercase mb-8"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "clamp(40px, 6vw, 70px)",
                  letterSpacing: "0.05em",
                  lineHeight: "1.1"
                }}
              >
                Treino para resultados reais
              </h2>
              <p 
                className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Mais do que um estúdio, o ULTIMATE FIT é um compromisso com a tua saúde, o teu progresso e o teu bem-estar - a longo prazo.
              </p>
              <p 
                className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                É um espaço funcional, equipamento completo e profissionais dedicados — o essencial para treinares ao teu melhor nível.
              </p>
              <p 
                className="text-gray-700 text-base md:text-lg leading-relaxed"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Para quem procura também a energia do grupo, contamos com aulas de grupo como Pilates — onde a técnica, o foco e o bem-estar se encontram num formato partilhado e motivador.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Filosofia / Missão */}
      <section className="py-14 sm:py-20 md:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center max-w-6xl mx-auto">
            <div className="order-2 md:order-1">
              <img 
                src="/assets/ult-filosofia.webp"
                alt="A Nossa Filosofia - ULTIMATE FIT"
                loading="lazy"
                className="w-full h-auto"
                style={{ filter: "grayscale(0.15)" }}
              />
            </div>
            <div className="order-1 md:order-2">
              <h2 
                className="text-black uppercase mb-6 sm:mb-8"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  fontSize: "clamp(40px, 7vw, 90px)",
                  letterSpacing: "0.05em",
                  lineHeight: "1.05"
                }}
              >
                A Nossa Filosofia
              </h2>
              <p 
                className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                O nome ULTIMATE representa o nosso compromisso: levar cada cliente ao seu máximo potencial.
              </p>
              <p 
                className="text-gray-700 text-lg mb-8 leading-relaxed"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Acreditamos que a transformação verdadeira acontece quando disciplina, orientação profissional e motivação se encontram. Não há atalhos. Apenas trabalho consistente, planeamento estratégico e execução impecável.
              </p>
              
              <div className="space-y-6">
                <div className="border-l-4 border-[#facc15] pl-6">
                  <h3 
                    className="text-black text-2xl mb-2"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "1px"
                    }}
                  >
                    Personalização Total
                  </h3>
                  <p 
                    className="text-gray-600"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "0.5px"
                    }}
                  >
                    Cada treino é desenhado exclusivamente para ti, respeitando o teu corpo, objetivos e ritmo.
                  </p>
                </div>
                
                <div className="border-l-4 border-[#facc15] pl-6">
                  <h3 
                    className="text-black text-2xl mb-2"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "1px"
                    }}
                  >
                    Resultados Mensuráveis
                  </h3>
                  <p 
                    className="text-gray-600"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "0.5px"
                    }}
                  >
                    Acompanhamos a tua evolução com rigor, ajustando estratégias para garantir progresso constante.
                  </p>
                </div>
                
                <div className="border-l-4 border-[#facc15] pl-6">
                  <h3 
                    className="text-black text-2xl mb-2"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "1px"
                    }}
                  >
                    Excelência Profissional
                  </h3>
                  <p 
                    className="text-gray-600"
                    style={{
                      fontFamily: "'BebasNeue-Book', sans-serif",
                      letterSpacing: "0.5px"
                    }}
                  >
                    A nossa equipa é formada pelos melhores. Certificados, experientes e dedicados ao teu sucesso.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipa CTA */}
      <section className="py-12 sm:py-14 md:py-16 bg-[#facc15]">
        <div className="container mx-auto px-4 sm:px-6 text-center">
          <h2 
            className="text-black uppercase mb-6"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(40px, 6vw, 70px)",
              letterSpacing: "0.05em"
            }}
          >
            A Equipa ULTIMATE
          </h2>
          <p 
            className="text-black text-lg md:text-xl mb-8 max-w-3xl mx-auto"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              letterSpacing: "0.5px"
            }}
          >
            Personal trainers certificados, especializados e comprometidos com a tua transformação. Conhece a equipa que vai elevar o teu treino a outro nível.
          </p>
          <button
            onClick={() => navigate('/equipa')}
            className="bg-black hover:bg-gray-900 text-white uppercase px-8 sm:px-12 py-4 transition-colors w-full sm:w-auto max-w-sm sm:max-w-none"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(18px, 2.2vw, 24px)",
              letterSpacing: "1px",
              borderRadius: "0px"
            }}
          >
            Conhecer a Equipa
          </button>
        </div>
      </section>

      {/* Serviços Premium */}
      <section className="py-14 sm:py-20 md:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
          <h2 
            className="text-black uppercase mb-10 sm:mb-14 md:mb-16 text-center"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(40px, 7vw, 90px)",
              letterSpacing: "0.05em",
              lineHeight: "1.05"
            }}
          >
            O Que Oferecemos
          </h2>
          
          <div className="space-y-14 sm:space-y-16 md:space-y-20">
            {/* Serviço 1 */}
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h3 
                  className="text-black text-4xl md:text-5xl uppercase mb-6"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "1px"
                  }}
                >
                  Personal Training
                </h3>
                <p 
                  className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  Sessões individuais com acompanhamento dedicado e exclusivo. Cada exercício, cada série, cada ajuste é pensado para ti. Alcança os teus objetivos mais rápido com orientação profissional constante.
                </p>
                <p 
                  className="text-gray-600 text-lg"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  Ideal para: Hipertrofia, perda de peso, performance atlética, reabilitação.
                </p>
              </div>
              <div>
                <OptimizedImage 
                  src="/assets/personal-training.png"
                  alt="Personal Training"
                  className="w-full h-auto"
                  style={{ filter: "grayscale(0.2)" }}
                  loading="lazy"
                />
              </div>
            </div>

            {/* Serviço 2 */}
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="order-2 md:order-1">
                <OptimizedImage 
                  src="/assets/ult-aulas-grupo.webp"
                  alt="Aulas de Grupo - Ultimate Fit"
                  className="w-full h-auto aspect-[3/4] md:aspect-auto object-cover"
                  style={{ filter: "grayscale(0.15)", objectPosition: "center 30%" }}
                  loading="lazy"
                />
              </div>
              <div className="order-1 md:order-2">
                <h3 
                  className="text-black text-4xl md:text-5xl uppercase mb-6"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "1px"
                  }}
                >
                  Aulas de Grupo
                </h3>
                <p 
                  className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  Treina em grupo com a energia contagiante de quem partilha os mesmos objetivos. Aulas dinâmicas, desafiantes e motivadoras, sempre orientadas por profissionais certificados.
                </p>
                <p 
                  className="text-gray-600 text-lg"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  Ideal para: Motivação extra, espírito de equipa, diversidade de treino.
                </p>
              </div>
            </div>

            {/* Serviço 3 */}
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h3 
                  className="text-black text-4xl md:text-5xl uppercase mb-6"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "1px"
                  }}
                >
                  Planeamento Nutricional
                </h3>
                <p 
                  className="text-gray-700 text-base md:text-lg mb-6 leading-relaxed"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  O treino é apenas metade da equação. Trabalhamos em parceria com nutricionistas qualificados para criar planos alimentares adaptados aos teus objetivos e estilo de vida.
                </p>
                <p 
                  className="text-gray-600 text-lg"
                  style={{
                    fontFamily: "'BebasNeue-Book', sans-serif",
                    letterSpacing: "0.5px"
                  }}
                >
                  Ideal para: Maximizar resultados, saúde sustentável, performance otimizada.
                </p>
              </div>
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=800&q=80"
                  alt="Nutrição"
                  className="w-full h-auto"
                  style={{ filter: "grayscale(0.2)" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experiência / Ambiente */}
      <section className="py-14 sm:py-20 md:py-24 bg-black text-white">
        <div className="container mx-auto px-4 sm:px-6 max-w-5xl text-center">
          <h2 
            className="uppercase mb-6 sm:mb-8"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(40px, 7vw, 90px)",
              letterSpacing: "0.05em",
              lineHeight: "1.05"
            }}
          >
            A Experiência ULTIMATE
          </h2>
          <p 
            className="text-gray-300 text-base sm:text-lg md:text-xl mb-10 sm:mb-12 leading-relaxed"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              letterSpacing: "0.5px"
            }}
          >
            Mais do que um ginásio, o ULTIMATE FIT é um espaço funcional onde encontras tudo o que precisas para treinar ao mais alto nível.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mt-10 sm:mt-14 md:mt-16">
            <div>
              <div 
                className="text-[#facc15] text-6xl mb-4"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif"
                }}
              >
                01
              </div>
              <h3 
                className="text-white text-2xl mb-4 uppercase"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "1px"
                }}
              >
                Equipamento Profissional
              </h3>
              <p 
                className="text-gray-400"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Equipamento de qualidade, pesos livres profissionais e tecnologia ao teu dispor.
              </p>
            </div>
            
            <div>
              <div 
                className="text-[#facc15] text-6xl mb-4"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif"
                }}
              >
                02
              </div>
              <h3 
                className="text-white text-2xl mb-4 uppercase"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "1px"
                }}
              >
                Ambiente Familiar
              </h3>
              <p 
                className="text-gray-400"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Espaço moderno, climatizado e pensado para maximizar o teu foco e rendimento.
              </p>
            </div>
            
            <div>
              <div 
                className="text-[#facc15] text-6xl mb-4"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif"
                }}
              >
                03
              </div>
              <h3 
                className="text-white text-2xl mb-4 uppercase"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "1px"
                }}
              >
                Acompanhamento Exclusivo
              </h3>
              <p 
                className="text-gray-400"
                style={{
                  fontFamily: "'BebasNeue-Book', sans-serif",
                  letterSpacing: "0.5px"
                }}
              >
                Atenção personalizada do início ao fim. Cada treino é monitorizado e ajustado em tempo real.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Secção Emocional / Transformação */}
      <section 
        className="py-20 sm:py-24 md:py-32 bg-cover bg-center md:bg-fixed relative ult-transformacao-bg"
        style={{
          backgroundImage: "url('/assets/ult-transformacao.webp')"
        }}
      >
        <div className="absolute inset-0 bg-black opacity-70"></div>
        <div className="relative z-10 container mx-auto px-4 sm:px-6 text-center max-w-4xl">
          <h2 
            className="text-white uppercase mb-6 sm:mb-8"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(40px, 7vw, 90px)",
              letterSpacing: "0.05em",
              lineHeight: "1.05"
            }}
          >
            A Tua Transformação Começa Aqui
          </h2>
          <p 
            className="text-white text-base md:text-lg mb-8 sm:mb-12 leading-relaxed max-w-3xl mx-auto"
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 300,
              letterSpacing: "0.01em",
              lineHeight: "1.6"
            }}
          >
            Não importa onde estás agora. Importa para onde vais. Todos os dias, os nossos clientes provam que com orientação certa, disciplina e compromisso, qualquer objetivo é alcançável.
          </p>
          <p 
            className="text-[#facc15] text-xl sm:text-2xl md:text-3xl uppercase"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              letterSpacing: "2px"
            }}
          >
            Junta-te a quem já escolheu ser ULTIMATE.
          </p>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-14 sm:py-20 md:py-24 bg-[#facc15]">
        <div className="container mx-auto px-4 sm:px-6 text-center max-w-4xl">
          <h2 
            className="text-black uppercase mb-5 sm:mb-6"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(40px, 7vw, 90px)",
              letterSpacing: "0.05em",
              lineHeight: "1.05"
            }}
          >
            Pronto para Começar?
          </h2>
          <p 
            className="text-black text-base sm:text-xl md:text-2xl mb-8 sm:mb-12"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              letterSpacing: "0.5px"
            }}
          >
            Agenda a tua avaliação física gratuita e descobre como podemos transformar os teus objetivos em resultados concretos.
          </p>
          <button
            onClick={() => setIsFormOpen(true)}
            className="bg-black hover:bg-gray-900 text-white uppercase px-8 sm:px-12 md:px-16 py-4 sm:py-5 transition-colors w-full sm:w-auto max-w-md sm:max-w-none whitespace-normal sm:whitespace-nowrap"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              fontSize: "clamp(18px, 2.5vw, 26px)",
              letterSpacing: "1px",
              borderRadius: "0px"
            }}
          >
            MARCAR AVALIAÇÃO FÍSICA GRATUITA
          </button>
        </div>
      </section>

      {/* Popup Form */}
      <AvaliacaoDialog 
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
      />
      
      <Footer />
    </div>
  );
};

export default Ultimate;
